export default [
    {
        path: '/spend-import-log',
        name: 'PageSpendsParsingLogList',
        meta: { title: 'spendsParsingLog.listTitle', roles: ['ADMIN'], permissions: ['partners_spend_view', 'spend_parse_log'] },
        component: () => import('@/pages/spends-parsing-log'),
    },
]
